import ForgotPasswordComponent from "../component/forgotPassword/forgotPassword";

function ForgotPasswordPage() {
  return <ForgotPasswordComponent />;
}
export default ForgotPasswordPage;
